var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',{class:_vm.titleName ? 'normal' : 'nomore'},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"header-date"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.nowDate))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }